import React from 'react';

const EstonianPage = () => {
    return (
        <div>
            <h3>
                <span lang="et">Lugupeetud õppejõud!</span>
            </h3>
            <h3>
                <span lang="et">
                    Tere tulemast kasutama Refleksioonikompassi teaduseetika õpetamisel!
                </span>
            </h3>
            <p>
                <span lang="et">
                    Refleksioonikompassi rakendus on loodud toetama õpetajaid teaduseetika
                    õpetamisel ning toetama üliõpilasi refleksiooniülesannete täitmisel
                    teaduseetikas.
                </span>
            </p>

            <p>
                <span lang="et">
                    Paljudesse kursustesse on integreeritud teaduseetika elemendid – näiteks
                    teadusseminarid, metoodikakursused, akadeemiline kirjutamine, retsenseerimine
                    või publitseerimisega seotud seminarid. Lisaks on refleksioon oluline eetilise
                    tundlikkuse t
                </span>
                <span lang="et">õ</span>
                <span lang="et">
                    stmisel. Teaduseetika ja refleksioonioskuste hindamine võib olla keeruline, et
                    teha kindlaks, mida ja kuidas üliõpilased õpivad. Lisaks võivad üliõpilased
                    tugineda AI-tööriistadele ülesannete täitmisel, mis on sageli aktsepteeritav,
                    kuid kui seda tehakse ilma oma mõtlemise ja refleksioonita, on küsitav, mida
                    üliõpilased tegelikult on õppinud. Õpetajad võivad soovida vältida soovimatut AI
                    kasutamist ja silma peal hoida üliõpilaste õppeprotsessil ilma, et neid liigselt
                    koormataks.
                </span>
            </p>

            <h3>
                <span lang="et">Mis rakendus see on? </span>
            </h3>

            <p>
                <span lang="et">
                    Tutvustame teaduspõhist tööriista ülikooliõpetajatele, kes käsitlevad oma
                    õpetamises teaduseetikat. Rakenduse on välja töötanud teaduseetika eksperdid ja
                    pedagoogid, et aidata õpetajaid …
                </span>
            </p>

            <p>
                <span lang="et">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="et">
                    selgitada, mida üliõpilased õpivad ja kas õpetamine on tõhus;{' '}
                </span>
            </p>

            <p>
                <span lang="et">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="et">
                    jälgida, kuidas üliõpilased mõistavad kursusel käsitletud eetikateemasid;{' '}
                </span>
            </p>

            <p>
                <span lang="et">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="et">
                    rakendada formaalset hindamist ja anda üliõpilastele tagasisidet kursuse ajal;{' '}
                </span>
            </p>

            <p>
                <span lang="et">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="et">
                    julgustada üliõpilasi mõtlema oma õppimisele ja toetada üliõpilaste
                    refleksioonioskuste arendamist;{' '}
                </span>
            </p>

            <p>
                <span lang="et">
                    •<span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</span>
                </span>
                <span lang="et">toetada üliõpilasi oma arusaamise hindamise õppimisel.</span>
            </p>

            <h3>
                <span lang="et">Kuidas rakendus töötab? </span>
            </h3>

            <p>
                <span lang="et">
                    Rakendus juhendab õpetajat looma kursust ülesannetega, mis nõuavad üliõpilaste
                    refleksiooni. Pärast kursuse ja ülesannete looist (on hea mõte lisada ühte
                    kursusesse mitu ülesannet, ülesande aeg näitab, millal üliõpilased saavad neid
                    teha), kopeerib õpetaja kutse, mida jagatakse üliõpilastega. Õpetajad saavad ka
                    oma kursusi ja ülesandeid dubleerida ja kasutada neid tulevastel semestritel
                    (kursustel on unikaalsed ID-d, mis aitavad eristada erinevaid aastaid ja
                    gruppe).
                </span>
            </p>

            <p>
                <span lang="et">
                    Üliõpilased logivad sisse oma tunnustega ja saavad minna ülesandele, mille
                    õpetaja on kutselingis märkinud. Üliõpilased teevad kaks ülesannet – esmalt
                    reflekteerivad nad ülesandes märgitud teemat, kirjutades lõigu vastavalt
                    ülesande 1 kirjeldusele. Seejärel loevad nad viit väidet ja valivad selle, mis
                    kõige paremini kirjeldab nende arusaamist teemast, mida nad just reflekteerisid.
                    Pärast vastuse esitamist näevad nad automaatset tagasisidet, mis kirjeldab nende
                    valitud arusaamise taset. Rakendus julgustab üliõpilasi mõtlema, kas nende
                    esitatud refleksioon vastab tagasisides kirjeldatud arusaamise tasemele.
                    Üliõpilastel on võimalus oma vastusele tagasi minna ja redigeerida kas oma
                    kirjutatud lõiku või oma arusaamise taset.
                </span>
            </p>

            <p>
                <span lang="et">
                    Rakendus analüüsib märgitud arusaamise tasemeid ja esitab tulemused õpetajale
                    sektordiagrammina (vt joonis 1).
                </span>
            </p>

            <p align="center">
                <span lang="et">
                    <img
                        alt="Joonis 1. Sektordiagramm ülesande tulemustega."
                        width="500"
                        height="auto"
                        src="/image003.png"
                    />
                </span>
            </p>

            <p>
                <span lang="et">Joonis 1. Sektordiagramm ülesande tulemustega.</span>
            </p>

            <p>
                <span lang="et">
                    Lisaks saavad nii õpetaja kui üliõpilased näha õppimise edenemist
                    lineaardiagrammis (vt joonis 2).
                </span>
            </p>

            <p align="center">
                <span lang="et">
                    <img
                        alt="Joonis 2. Lineaardiagramm üliõpilaste edusammudega."
                        width="700"
                        height="auto"
                        src="/image004.png"
                    />
                </span>
            </p>

            <p>
                <span lang="et">Joonis 2. Lineaardiagramm üliõpilaste edusammudega.</span>
            </p>

            <p>
                <span lang="et">
                    Õpetaja saab lugeda ka üliõpilaste refleksioone ja anda isiklikumat tagasisidet
                    (kirjaliku tekstina või märkides õpetaja hinnangu arusaamise tasemele, mida
                    üliõpilase kirjutatud lõik näitab).
                </span>
            </p>

            <p>
                <span lang="et">
                    Rakenduse kasutamine toetab peamiselt üliõpilaste reflektiivset õppimist ja
                    kujundavat hindamist kursuse ajal, kuid õppeprotsessi kuvamine diagrammis toimib
                    hästi järgneva 'refleksioonipäeviku' alusena. Diagrammi saab üliõpilane v
                </span>
                <span lang="et">õtta aluseks</span>
                <span lang="et">, kui ta oma õppeprotsessi refleksioonipäevikus kokku v</span>
                <span lang="et">õ</span>
                <span lang="et">
                    tavad. Refleksioonipäevikut saab kasutada summatiivse hindamise eesmärgil, st
                    hindamistegevusena, mis aitab kaasa kursuse lõplikule hindamisele, mis vïb olla
                    hindeline.
                </span>
            </p>

            <p>
                <span lang="et">
                    Rakenduse korduv kasutamine annab õpetajatele ülevaate, kuidas üliõpilased
                    edenevad, millised teemad tunduvad olevat keerulisemad ja millised on omandatud.
                    Üliõpilased saavad ka oma edusamme diagrammis näha ning rakenduse ja õpetaja
                    antud tagasisidet lugedes saavad nad arendada oma refleksioonioskusi.
                </span>
            </p>

            <p>
                <span lang="et">&nbsp;</span>
            </p>

            <p>
                <span lang="et">&nbsp;</span>
            </p>

            <p>
                <span lang="et">Arusaamise tasemed põhinevad SOLO taksonoomial: </span>
            </p>

            <p>
                <span lang="et">Sümbol </span>
                <span lang="et">
                    <img alt="Vajan abi arusaamiseks" width="12" height="12" src="/image005.png" />
                </span>
                <span lang="et">
                     näitab vajadust abi mõistmiseks. Oma arusaamise taseme parandamiseks võib
                    õppija parandada oma eetilist pädevust, konsulteerides asjakohaste
                    käitumisjuhenditega ja arutades kogenud teadlastega, kuidas nad mõtlevad õigete
                    valikute tegemisele teadustöös.{' '}
                </span>
            </p>

            <p>
                <span lang="et">Sümbol </span>
                <span lang="et">
                    <img alt="Ilmnev arusaamine" width="13" height="13" src="/image006.png" />
                </span>
                <span lang="et">
                     näitab arenevat arusaamist. Õppijat julgustatakse mõtlema seotud küsimustele
                    või uutele küsimustele, mis võivad tuleneda algsest probleemist, on hea mõte
                    kaardistada, kes on olukorrast huvitatud ja milliseid erinevaid küsimusi nad
                    olukorra kohta esitaksid.{' '}
                </span>
            </p>

            <p>
                <span lang="et">Sümbol </span>
                <span lang="et">
                    <img alt="Mõõdukas arusaamine" width="17" height="17" src="/image007.png" />
                </span>
                <span lang="et">
                     näitab mõõdukat arusaamist. Õppija peaks püüdma näha seoseid erinevate
                    eetiliste aspektide vahel teadustöös ja mõtlema näidetele nende seoste
                    kirjeldamiseks.{' '}
                </span>
            </p>

            <p>
                <span lang="et">Sümbol </span>
                <span lang="et">
                    <img alt="Sidus arusaamine" width="16" height="16" src="/image008.png" />
                </span>
                <span lang="et">
                     näitab sidusat arusaamist. Õppijale soovitatakse rakendada oma teadmisi
                    erinevates kontekstides ja aidata teisi.{' '}
                </span>
            </p>

            <p>
                <span lang="et">
                    Sümbol{' '}
                    <img alt="Sügavuti arusaamine" width="19" height="19" src="/image009.png" />
                     näitab sügavat arusaamist. Õppija võib olla mõelnud endale kui eeskujule hea
                    teadusliku praktika edendamisel laiemalt teadlaskonnas ja aitamisel luua
                    eetiliselt jätkusuutlik teaduskultuur.
                </span>
            </p>

            <h3>
                <span lang="et">Millistel uuringutel rakendus tugineb? </span>
            </h3>

            <p>
                <span lang="et">Refleksioonikompass on üles ehitatud uurimis- ja disainip</span>
                <span lang="et">õ</span>
                <span lang="et">him</span>
                <span lang="et">õ</span>
                <span lang="et">
                    tetele ning kasutab <i>Structure of Observed Learning Outcomes</i> (SOLO)
                    taksonoomiat, et pakkuda kindlat alust tulemustele. Kombineerides rakenduse
                    tulemusi, jälgides üliõpilaste tööd klassis ja erinevatel ajahetkedel kursuse
                    jooksul esitatud töid, saab õpetaja tervikliku pildi üliõpilaste arengust ja
                    koolituse tõhususest.
                </span>
            </p>

            <p>
                <span lang="et">
                    Kui olete huvitatud SOLO taksonoomiast või uurimistööst, millele rakendus
                    tugineb, külastage järgmisi linke:{' '}
                </span>
            </p>

            <p>
                <span lang="et">
                    SOLO taksonoomia:{' '}
                    <a href="https://www.johnbiggs.com.au/academic/solo-taxonomy/">
                        https://www.johnbiggs.com.au/academic/solo-taxonomy/
                    </a>
                </span>
            </p>

            <p>
                <span lang="et">
                    Artikkel: John Biggs (1999) What the Student Does: teaching for enhanced
                    learning, Higher Education Research &amp; Development, 18:1, 57-75, DOI:
                    10.1080/0729436990180105
                </span>
            </p>

            <p>
                <span lang="et">Link artiklile: </span>
                <span lang="et">
                    <a href="https://www.tandfonline.com/doi/pdf/10.1080/0729436990180105">
                        <span lang="et">
                            https://www.tandfonline.com/doi/pdf/10.1080/0729436990180105
                        </span>
                    </a>
                </span>
                <span lang="et"> </span>
            </p>

            <p>
                <span lang="et">Uurimistöö refleksioonirakenduse arendamise kohta: </span>
            </p>

            <p>
                <span lang="et">
                    Artikkel: Anu Tammeleht &amp; Erika Löfström (2024) Learners’ self-assessment as
                    a measure to evaluate the effectiveness of research ethics and integrity
                    training: can we rely on self-reports?, <i>Ethics &amp; Behavior</i>, 34:8,
                    575-596, DOI: 10.1080/10508422.2023.2266073{' '}
                </span>
            </p>

            <p>
                <span lang="et">Link artiklile: </span>
                <span lang="et">
                    <a href="https://www.tandfonline.com/doi/pdf/10.1080/10508422.2023.2266073">
                        <span lang="et">
                            https://www.tandfonline.com/doi/pdf/10.1080/10508422.2023.2266073
                        </span>
                    </a>
                </span>
                <span lang="et"> </span>
            </p>

            <p>
                <span lang="et">Rakenduse arendamist toetas: </span>
            </p>

            <p>
                <span lang="et">
                    <img alt="Beyond apples logo" width="214" height="auto" src="/image011.png" />
                </span>
                <span lang="et">
                     {' '}
                    <img alt="European union logo" width="117" height="auto" src="/image012.png" />
                       
                </span>
                <span lang="et">
                    <img
                        border="0"
                        width="200"
                        height="auto"
                        src="/image013.png"
                        alt="Reimagining Teachers and Teacher Education for our Futures | University of  Helsinki"
                    />
                </span>
            </p>
        </div>
    );
};

export default EstonianPage;
